'use client'

import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'
import { Heading } from '@/shared/ui/heading'
import { Icon } from '@/shared/ui/icon'

import cl from './client-side-error.module.scss'

export const ClientSideError = () => {
	const reloadPage = () => {
		window.location.reload()
	}

	return (
		<div className={cl.root}>
			<div className={cl.content}>
				<Icon name="IPortTool" size={64} className={cl.icon} />
				<Heading preset="h1" className={cl.heading}>
					Технические неполадки
				</Heading>
				<Text size="7" className={cl.text} style={{ marginBottom: '48px' }}>
					Это временно, скоро всё наладим
				</Text>
				<Button onClick={reloadPage} className={cl.button}>
					Перезагрузить
				</Button>
			</div>
		</div>
	)
}
